import { Box, Spinner } from "@modernatx-internal/component-library";
import React from "react";

export const PDFViewerLoader: React.FC<{ loading: boolean }> = ({ loading }) => {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: loading ? "100vh" : null
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          backgroundColor: "white",
          border: "1px solid",
          borderColor: "stroke-neutral-secondary",
          display: loading ? "flex" : "none",
          flexDirection: "column",
          left: 0,
          position: "absolute",
          pb: () => "30%",
          pt: 20,
          top: 0,
          width: "100%"
        }}
      >
        <Spinner size="xl" />
      </Box>
    </Box>
  );
};
